import React from 'react';
import { ModalBody, ModalFooter, Modal, Button } from "reactstrap";
import ReactCrop from 'react-image-crop';
import Request from '../../common/Request';
import Base64 from '../../common/Base64';
import AlertModal from 'views/ViewParts/AlertModal'
import 'react-image-crop/dist/ReactCrop.css';

class ImageControl extends React.Component {
  
  constructor(props){
    super(props);
    this.state = {
        src: null,
        crop: props.cropData===undefined?{
          unit: '%',
          width: 30,
          aspect: (32 / 10),
        }:props.cropData,
        modal: false,
        croppedImageUrl: null,
        name:"",
        is_image: true
      };
    
    this.imageFile = React.createRef();
    this.alertModal = React.createRef();
    this.toggleModal = this.toggleModal.bind(this)
    this.upload = this.upload.bind(this)
  }
  
  onSelectFile = e => {
    if (e.target.files && e.target.files.length > 0) {
      const reader = new FileReader()
      const file = e.target.files[0]

      // イメージファイル、PDF以外はエラーとする
      if(this.props.checkMode === "FAX" && !(file.type.includes("image/") || file.type == "application/pdf")){
        this.alertModal.current.showErrorModal({messageNo:2490})
        return;
    }
      reader.addEventListener('load', () =>{
        const imageFileRegex = RegExp(':image/','i')
        const isImage = imageFileRegex.test(reader.result)
        if (imageFileRegex.test(reader.result)){
          this.setState({
            src: reader.result,
            name: file.name,
            is_image: isImage,
            modal:true,
            crop: this.props.cropData===undefined?{
              unit: '%',
              width: 30,
              aspect: (32 / 10),
            }:this.props.cropData,
          })
        } else {
          this.setState({
            croppedImageUrl: reader.result,
            name:file.name,
            is_image: isImage,
          }, ()=>{this.upload()})
        }
      })
      reader.readAsDataURL(file)
    }
  };

  // If you setState the crop in here you should return false.
  onImageLoaded = image => {
    this.imageRef = image;
  };

  onCropComplete = crop => {
    this.makeClientCrop(crop);
  };

  onCropChange = (crop, percentCrop) => {
    this.setState({ crop });
  };

  async makeClientCrop(crop) {
    if (this.imageRef && crop.width && crop.height) {
      const croppedImageUrl = await this.getCroppedImg(
        this.imageRef,
        crop,
        'newFile.jpeg'
      );
      this.setState({ croppedImageUrl });
    }
  }

  getCroppedImg(image, crop, fileName) {
    const canvas = document.createElement('canvas');
    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;
    canvas.width = crop.width;
    canvas.height = crop.height;
    const ctx = canvas.getContext('2d');

    ctx.drawImage(
      image,
      crop.x * scaleX,
      crop.y * scaleY,
      crop.width * scaleX,
      crop.height * scaleY,
      0,
      0,
      crop.width,
      crop.height
    );

    return new Promise((resolve, reject) => {
      canvas.toBlob(blob => {
        if (!blob) {
          console.error('Canvas is empty');
          return;
        }
        blob.name = fileName;
        window.URL.revokeObjectURL(this.fileUrl);
        this.fileUrl = window.URL.createObjectURL(blob);
        resolve(this.fileUrl);
      }, 'image/jpeg');
    });
  }

  toggleModal(){
      this.setState({
          modal:!this.state.modal,
          src: this.state.modal?null:this.state.src,
          croppedImageUrl: this.state.modal?null:this.state.src,
      })
      if (this.state.modal){
        this.imageFile.current.value=""
      }
  }

  upload(){
    Base64.getBase64(this.state.croppedImageUrl, ((result) => {
      const params = {
        image_base64:result,
        // folder_id:this.props.imageFolderId?this.props.imageFolderId:""
        gcs_path: (this.props.gcs_path?this.props.gcs_path:'parking_picture')
      }
      const url = "/api/gcs_upload"
      Request.post(url, params, res => {
        const {
          id,
          folder_id,
        } = res.Data
        this.props.uploadCallback({
          name: this.state.name,
          file:params.base64, 
          id,
          imageFolderId: folder_id,
          is_image: this.state.is_image
        })
      });
    }));
  }

  render() {
    const { crop, croppedImageUrl, src, modal } = this.state;
    return (
      <>
        {this.props.imageButton ? 
          <label>
            <span className="btn btn-secondary btn-sm" style={{backgroundColor:'transparent', border:'1px solid #344675', borderRadius:'5px', backgroundImage:'none'}}>
              <img src="/camera-solid.svg" width="32" height="32" alt="＋画像" />
              <input ref={this.imageFile} style={{display:"none"}} type="file" accept="image/*" onChange={this.onSelectFile}/>
            </span>
          </label>
        :
          <label className="btn btn-sm" style={{color:'white'}}>{this.props.buttonName||"ファイル追加"}
            <input ref={this.imageFile} style={{display:"none"}} type="file" accept={this.props.accept||"image/*"} onChange={this.onSelectFile}/>
          </label>
        }
        <Modal isOpen={this.state.modal}>
          <div className="modal-header">
            <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={this.toggleModal}>
              <i className="tim-icons icon-simple-remove"></i>
            </button>
            <h5 className="modal-title">ImageUpload</h5>
          </div>
          <ModalBody>
            <ReactCrop
                src={src}
                crop={crop}
                ruleOfThirds
                onImageLoaded={this.onImageLoaded}
                onComplete={this.onCropComplete}
                onChange={this.onCropChange}
            />
            {croppedImageUrl && (
            <img alt="Crop" style={{ maxWidth: '100%' }} src={croppedImageUrl} />
            )}
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={this.toggleModal}>
              いいえ
            </Button>
            <Button color="info" onClick={() => { this.toggleModal(); this.upload(); }}>
              はい
            </Button>
          </ModalFooter>
        </Modal>
        <AlertModal ref={this.alertModal}/>
      </>
    );
  }
}

export default ImageControl;
